import { render, staticRenderFns } from "./sysStudentSituation.vue?vue&type=template&id=14801d8a&"
import script from "./sysStudentSituation.vue?vue&type=script&lang=js&"
export * from "./sysStudentSituation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports